import {Observable, Subscription} from 'rxjs';

import ITimelineStore from '../Interfaces/ITimelineStore';

const subscribeToTimelineTap = (
    timelineTap$: Observable<void>,
    timelineStore: ITimelineStore
): Subscription =>
    timelineTap$
        .subscribe(() => {
            if (timelineStore.value.isScrubbing) {
                timelineStore.actions.track();
            }
        });

export default subscribeToTimelineTap;